import { useCallback, useEffect, useMemo, useState } from "react";
import { getInvestorPortalBySubdomain } from "../services/portalService";
import { InvestorPortal } from "../types/InvestorPortal";

export function usePortalDefinition() {
  const [investorPortal, setInvestorPortal] = useState<InvestorPortal | null>(
    null,
  );
  const hostname = window.location.hostname;

  const handlePortalNavigation = useCallback(async (portalId: string) => {
    const portal = await getInvestorPortalBySubdomain(portalId);
    setInvestorPortal(portal);
  }, []);

  useEffect(() => {
    const portalId = hostname.split(".")[0];
    if (portalId) {
      handlePortalNavigation(portalId);
    }
  }, [hostname, handlePortalNavigation]);

  return useMemo(() => {
    return {
      investorPortal,
    };
  }, [investorPortal]);
}
